import s from './Button.module.css';

export default function Button({
  variant = 'secondary',
  size = 'md',
  as: Tag = 'button',
  type,
  children,
  className = '',
  ...rest
}) {
  const cls = [s.btn, s[variant], s[size]].join(' ');
  const typeProp = Tag === 'button' ? { type: type || 'button' } : {};
  return (
    <Tag className={`${cls} ${className}`.trim()} {...typeProp} {...rest}>
      {children}
    </Tag>
  );
}
